import { useStaticQuery, graphql } from 'gatsby'
import { useLocation } from '@reach/router'

const SEO = ({ title, image, description, keywords }) => {
  const { prismicHomePage: { data } } = useStaticQuery(query)
  const location = useLocation()

  const fullTitle = title === 'Home' ? 'Snow Peak Campfield Long Beach' : `Snow Peak Campfield: ${title}`
  const currentDescription = description ?? data.seo[0].primary.description
  const currentKeywords = keywords ?? data.seo[0].primary.keywords
  const currentImage = image ?? data.hero[0].primary.desktop_image
  const currentImageURL = encodeURI(currentImage.url)
  const canonicalRef = `${process.env.GATSBY_CANONICAL_URL}${location.pathname}`

  return (
    <>
      <title>{fullTitle}</title>
      <link rel='canonical' href={canonicalRef} />
      <meta name='description' content={currentDescription} />
      <meta name='keywords' content={currentKeywords} />

      <meta property='og:title' content={fullTitle} />
      <meta property='og:type' content='website' />
      <meta property='og:image' content={currentImageURL} />
      <meta property='og:image:width' content={currentImage?.dimensions?.width} />
      <meta property='og:image:height' content={currentImage?.dimensions?.height} />
      <meta property='og:url' content={canonicalRef} />
      <meta property='og:description' content={currentDescription} />
      <meta property='og:site_name' content={fullTitle} />

      <meta name='twitter:card' content='summary' />
      <meta name='twitter:title' content={fullTitle} />
      <meta name='twitter:description' content={currentDescription} />
      <meta name='twitter:title' content={fullTitle} />
      <meta name='twitter:image' content={currentImageURL} />
      <meta name='twitter:url' content={canonicalRef} />

      <meta itemProp='name' content={fullTitle} />
      <meta itemProp='url' content={canonicalRef} />
      <meta itemProp='description' content={currentDescription} />
      <meta itemProp='image' content={currentImageURL} />
      <meta itemProp='thumbnailUrl' content={currentImageURL} />
    </>
  )
}

export default SEO

const query = graphql`
  query {
    prismicHomePage {
      data {
        hero {
          ... on PrismicHomePageDataHeroHero {
            primary {
              desktop_image {
                url
                dimensions {
                  height
                  width
                }
              }
            }
          }
        }
        seo {
          ... on PrismicHomePageDataSeoSeo {
            primary {
              description
              keywords
            }
          }
        }
      }
    }
  }
`